const AdobeStock_295693279_RED = require('./AdobeStock_295693279_RED.webp');
export default [AdobeStock_295693279_RED];
